import { attr, belongsTo } from 'spraypaint'
import ApplicationRecord from './ApplicationRecord'
import placeholder from '../assets/placeholder_elementary.png'

const SeniorImage = ApplicationRecord.extend({
  static: {
    jsonapiType: 'senior_images',
  },
  attrs: {
    extension: attr(),
    selectedForYearbook: attr(),
    url: attr(),
    index: attr(),
    dbPackageId: attr(),
    createdAt: attr(),
    updatedAt: attr(),
    imageUrl: attr(),
    imageFileName: attr(),
    watermarkUrl: attr(),
    studentImage: belongsTo(),
  },
  methods: {
    image() {
      let res = placeholder

      if (this.imageUrl) res = this.imageUrl
      else if (this.watermarkUrl) res = this.watermarkUrl

      return res
    },
    watermark() {
      if (this.watermarkUrl) return this.watermarkUrl

      return placeholder
    },
  },
})

export default SeniorImage
